import styles from "./Hero.module.scss";
import { useState, useRef, useEffect } from "react";

const Hero = () => {
  const [videoHeight, setVideoHeight] = useState(null);
  const refDescription = useRef();
  const refHero = useRef();

  function editVideoHeight() {
    const heightHero = refHero.current?.getBoundingClientRect().height;
    const heightDescription =
      refDescription.current?.getBoundingClientRect().height;
    if (window.innerWidth <= 962) {
      setVideoHeight(heightHero - heightDescription - 28);
    } else {
      setVideoHeight(null);
    }
  }

  window.onresize = () => {
    editVideoHeight();
  };

  useEffect(() => {
    editVideoHeight();
  }, []);

  return (
    <div className={styles.hero} ref={refHero}>
      <div className={styles.video} style={{ height: videoHeight }}>
        <video autoPlay muted loop playsInline>
          <source
            src="https://ch-sk-files.ch-sk.ru/tep-site/videos/mainVideo_webm.webm"
            type="video/webm"
          />
          <source
            src="https://ch-sk-files.ch-sk.ru/tep-site/videos/mainVideo_mp4.mp4"
            type="video/mp4"
          />
        </video>
      </div>
      <div className={styles.info} ref={refDescription}>
        <div className={`${styles.content} text regular light`}>
          ГК Трансэнергопром – энергетический холдинг, осуществляющий
          деятельность в 27 субъектах России
        </div>
      </div>
    </div>
  );
};

export default Hero;
